export const filterFactory = (name, filterFn) => ({
  install: app => {
    app.config.globalProperties.$filters = {
      ...app.config.globalProperties.$filters,
      [name]: filterFn
    }
  }
})
